// KYC.js
import React, { useState, useEffect } from "react";
import LoaderContainer from "../../components/LoaderContainer";
import { Container, Grid, Button } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import api from "../../globals/axios";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../components/Custom/CustomTextField";

import { useNavigate } from "react-router-dom";

function KYC() {
  const [profileData, setProfileData] = useState({
    // id: null,
    aadhar_number: "",
    pan_number: "",
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { t } = useTranslation();
  useEffect(() => {
    const loadDetails = async () => {
      api
        .get("/auth/appusers/")
        .then((res) => {
          const userData = res.data[0];
          if (userData) {
            setProfileData({
              aadhar_number: userData.aadhar_number || "",
              pan_number: userData.pan_number || "",
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    };
    loadDetails();
  }, []);
  // const handleFieldChange = (fieldName, value) => {
  //   setProfileData({ ...profileData, [fieldName]: value });
  // };
  const handleChange = (name, value) => {
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleClick = async () => {
    try {
      await api.patch("/auth/appusers/self/", profileData);
      navigate("/farmer/profile");
      console.log("KYC update Sucessfully");
    } catch (error) {
      console.error("Error updating profile data:", error);
    }
  };
  console.log("rpfo", profileData);
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container>
          <CustomTitle>{t("KYC")}</CustomTitle>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTextField
                label={t("Aadhar")}
                value={profileData.aadhar_number || ""}
                name="aadhar_number"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                label={t("Pan")}
                value={profileData.pan_number || ""}
                name="pan_number"
                onChange={handleChange}
                type={Number}
              />
            </Grid>
            <Grid item xs={8}></Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleClick}
                variant="contained"
                style={{ color: "white", width: "110px" }}
              >
                {t("Save")}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}

export default KYC;
